import React, { Component } from 'react';
import PropTypes from 'prop-types';

const MINIMUM_MESSAGE_FONT_SCALE = 0.2;

class ScalingTextBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fontScale: 1
    };
  }

  componentDidUpdate() {
    this.adjustFontScale();
  }

  componentDidMount() {
    this.adjustFontScale();
  }

  adjustFontScale() {
    if (this.textBlockInner && this.textBlockOuter) {
      const { fontScale } = this.state;

      if (
        fontScale > MINIMUM_MESSAGE_FONT_SCALE &&
        this.textBlockInner.clientHeight > this.textBlockOuter.clientHeight
      ) {
        this.setState({
          fontScale: fontScale - 0.1
        });
      }
    }
  }

  render() {
    const { fontScale } = this.state;
    const { maxHeight, children, cssClass } = this.props;

    return (
      <div style={{ maxHeight }} ref={outer => (this.textBlockOuter = outer)}>
        <div
          style={{ fontSize: fontScale + 'em' }}
          className={cssClass}
          ref={inner => (this.textBlockInner = inner)}
        >
          {children}
        </div>
      </div>
    );
  }
}

ScalingTextBlock.propTypes = {
  maxHeight: PropTypes.string,
  cssClass: PropTypes.string
};

export default ScalingTextBlock;



// WEBPACK FOOTER //
// ./src/components/ScalingTextBlock/index.js